import { useTranslation } from 'react-i18next';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import EXTERNAL_URLS from 'constants/externalUrls';
import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles({
  title: {
    display: 'flex',
    gap: '4px',
    marginLeft: '15px',
  },
});

const StripeModule = ({ handleModuleUpdate, module }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  if (!module) {
    return (
      <div>
        {t('brands.newBrandForm.moduleNotLoaded', {
          replace: 'StripeModule',
        })}
      </div>
    );
  }

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <h3 className={classes.title}>
            {t('paymentType.title.Stripe')}
            <InfoWithTooltip
              link={EXTERNAL_URLS.configurationStripe}
              linkText={t('paymentType.configurationStripe.tooltip')}
            />
          </h3>
        </GridItem>
      </GridContainer>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.stripe.publishableKey')}
          value={module.publishableKey}
          handleChange={e =>
            handleModuleUpdate({ ...module, publishableKey: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.stripe.secretKey')}
          value={module.secretKey}
          handleChange={e =>
            handleModuleUpdate({ ...module, secretKey: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.stripe.webhookSecret')}
          value={module.webhookSecret}
          handleChange={e =>
            handleModuleUpdate({ ...module, webhookSecret: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.stripe.subscriptionConditionsAddress')}
          value={module.rulesLink}
          handleChange={e =>
            handleModuleUpdate({
              ...module,
              rulesLink: e.target.value,
            })
          }
          inputSize={12}
          maxLength={255}
        />
      </GridItem>
    </>
  );
};

export default StripeModule;
